import { render, staticRenderFns } from "./NmicCriteriaCard.vue?vue&type=template&id=5859d2d0&scoped=true&"
import script from "./NmicCriteriaCard.vue?vue&type=script&lang=js&"
export * from "./NmicCriteriaCard.vue?vue&type=script&lang=js&"
import style0 from "./NmicCriteriaCard.vue?vue&type=style&index=0&id=5859d2d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5859d2d0",
  null
  
)

export default component.exports